import { render, staticRenderFns } from "./left-nav.vue?vue&type=template&id=1a22370e&scoped=true&"
import script from "./left-nav.vue?vue&type=script&lang=js&"
export * from "./left-nav.vue?vue&type=script&lang=js&"
import style0 from "./left-nav.vue?vue&type=style&index=0&id=1a22370e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a22370e",
  null
  
)

export default component.exports